


















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { RawTag as Tags } from '@/models/api/tags'

import Checkbox from '@/components/atoms/Checkbox.vue'

@Component({
  components: {
    Checkbox,
  },
})
export default class MailMagazineCheckItem extends Vue {
  @Prop({ default: 'li' })
  tag: string

  @Prop({ required: true })
  item: Tags

  @Prop({ default: null })
  change: ((changed: Tags) => void) | null

  handleChange() {
    const value = {
      ...this.item,
      ...{
        follow: !this.item.follow,
      },
    }
    if (this.change === null) {
      return
    }
    this.change(value)
  }
}
